import moment from "moment";
import { dataOrderDetailTable } from "../../../../model/SaleOrderModel";
import { EmployeeModel } from "../../../../model/Employee";
import { DepartmentModel } from "../../../../model/DepartmentModel";
import {
  repositoryDelivery,
  repositoryPos,
  repositoryMdm,
} from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { ProductModel } from "../../../../model/TblDMItem";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

export const formatDateString = (dateStr: string) => {
  if (dateStr === "") return "";
  const date = new Date(dateStr);
  const adjustedDate = date.setHours(date.getHours());
  return moment(new Date(adjustedDate)).format("DD-MM-YYYY HH:mm:ss");
};

export const formatDateStringCareSoft = (dateStr: string) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return moment(date).format("DD/MM/YY");
};

export function containsDT(input: string): boolean {
  return input.includes("DT");
}

export function getGroupCode(input: string) {
  return input.split("||")[1];
}

export const handleCheckIsSuccessValidateItem = (listAdd: any[]): boolean => {
  return listAdd
    .filter((item) => !item?.attribute11)
    .every((item) => item?.attribute14 && item?.attribute2);
};

export const formatOrderDate = (date: string | undefined) => {
  // Kiểm tra nếu `date` có tồn tại và bắt đầu bằng "0001"
  if (date && date.startsWith("0001")) {
    return "";
  }
  return date || ""; // Trả về giá trị gốc nếu không bắt đầu bằng "0001"
};

export const handleRenderOptionListAdd = (
  listAdd: any[],
): { value: string; label: string }[] => {
  return listAdd
    .filter((item) => item.lineTyle === "HT" && item.attribute13)
    .map((item) => ({
      value: item.attribute13,
      label: item.attribute13,
    }));
};

export const handleCheckBackgroundColor = (type: string): string => {
  switch (type) {
    case "G":
      return "#E5E6E7"; // Màu xám
    case "H":
      return "#E5E6E7"; // Màu xám
    case "T":
      return "#E5E6E7"; // Màu đỏ cho sp trả
    default:
      return "white"; // Màu xám nếu không khớp với loại nào
  }
};

export const getTotalQuality = (items: dataOrderDetailTable[]): number => {
  return items?.reduce((total, item) => total + (item.quality || 0), 0);
};

// hàm check sản phẩm đã chọn hay chưa
export const handleCheckChooseProduct = (
  product: any,
  listAdd: any[],
): boolean => {
  if (product?.wareHouseCode === "K01_DA") return true;
  const found = listAdd.some(
    (item) => item.id === product.id && item.warehouse === product.warehouse,
  );
  return found;
};

export const handleCheckChooseProductBuon = (
  product: any,
  listAdd: any[],
): boolean => {
  const found = listAdd.some(
    (item) => item.id === product.id && item.warehouse === product.warehouse,
  );
  return found;
};

export const handleGetTechnicialRequireId = (name: string) => {
  const options = [
    "Không",
    "Lắp ráp(mới)",
    "Kiểm tra(mới)",
    "Lắp ráp(mới) + Kiểm tra(mới)",
  ];

  return options?.findIndex((item) => item === name) ?? 0;
};

export const handleGetTechnicialRequireName = (id: number) => {
  const options = [
    "Không",
    "Lắp ráp(mới)",
    "Kiểm tra(mới)",
    "Lắp ráp(mới) + Kiểm tra(mới)",
  ];

  return options[id];
};

export const handlerRenderOptionSelect = (object: any) => {
  if (object) {
    const newObject = object?.map((item: any) => {
      return item?.name;
    });
    return newObject;
  }
};

export const handlerRenderOptionSelectAccountant = (object: any) => {
  if (object) {
    const newObject = object?.map((item: any) => {
      return item?.fullname;
    });
    return newObject;
  }
};

export const handleGetNameEmployee = (Employee: EmployeeModel[]) => {
  const dataName = Employee?.map((item: any) => {
    return item?.fullName;
  });
  return dataName;
};

export const handleGetNameEmployeeAll = (Employee: any) => {
  const dataName = Employee?.map((item: any) => {
    return `${item?.fullname} - ${item?.code}`;
  });
  return dataName;
};

export const handleGetNameDepartment = (Department: DepartmentModel[]) => {
  const dataName = Department?.map((item: any) => {
    return item?.name;
  });
  return dataName;
};

export const handleGetNameBranch = (Branch: any[]) => {
  const dataName = Branch?.map((item: any) => {
    return item?.text;
  });
  return dataName;
};

export const handleKeyDown = (event: any) => {
  if (event.key === "-") {
    event.preventDefault();
  }
};

export const getDeliveryMethodCode = (value: string) => {
  switch (value) {
    case "Nhận tại cửa hàng":
      return "KHONG";
    case "Nội bộ":
      return "HACOM";
    case "Đối tác vận chuyển":
      return "DOI_TAC_VAN_CHUYEN";
    default:
      return null; // Giá trị mặc định nếu không có giá trị phù hợp
  }
};

export const parseAttribute19 = (attribute19?: string) => {
  try {
    return JSON.parse(attribute19 || "{}");
  } catch {
    return { machineCode: "", quantity: 0 };
  }
};

export const handlePaymentChange = (
  key: string,
  value: any,
  setters: {
    setCashPayment: (value: any) => void;
    setBankTransfer: (value: any) => void;
    setCardPayment: (value: any) => void;
    setVnpayPayment: (value: any) => void;
    setAnotherPayment: (value: any) => void;
  },
) => {
  switch (key) {
    case "cashPayment":
      setters.setCashPayment(value);
      break;
    case "bankTransfer":
      setters.setBankTransfer(value);
      break;
    case "cardPayment":
      setters.setCardPayment(value);
      break;
    case "vnpayPayment":
      setters.setVnpayPayment(value);
      break;
    case "anotherPayment":
      setters.setAnotherPayment(value);
      break;
    default:
      console.warn(`Unhandled payment key: ${key}`);
  }
};

export const handleQuantityChange = async (
  e: any,
  row: any,
  branchId: number | undefined,
  location: any,
  setListAdd: any,
) => {
  if (
    location?.state?.actionType !== "edit" &&
    row?.original?.lineTyle !== "DV"
  ) {
    // Lấy số lượng tồn kho từ API
    const url = `/api/v1/TblItem/search-sell?inv=${branchId}&key=${row?.original?.itemCode.toLowerCase()}`;
    const searchResult =
      await repositoryPos.get<MessageResponse<ProductModel[]>>(url);

    const ton = searchResult?.data?.find(
      (item) => item?.warehouse === row?.original?.warehouse,
    );

    const maxQuantity = (ton?.tons || 0) - (ton?.tonao || 0);

    // Kiểm tra nếu số lượng nhập vào lớn hơn tồn kho
    if (Number(e) > maxQuantity) {
      NotificationExtension.Warn(
        "Số lượng vừa nhập lớn hơn tồn hàng trong kho !",
      );

      // Đặt lại số lượng về tồn kho tối đa
      setListAdd((prevData: any) => {
        const updatedData = prevData.map((item: any, i: any) =>
          i === row.index
            ? {
                ...item,
                quality: maxQuantity,
                totalLineAmount: row?.original?.priceFinal * maxQuantity,
              }
            : item,
        );

        return updatedData.map((item: any) =>
          row?.original?.listIdGift?.includes(item?.id)
            ? {
                ...item,
                // Tạm bỏ logic thay đổi số lượng của quà
                // quality: maxQuantity,
              }
            : item,
        );
      });

      return; // Nếu không hợp lệ, đã đặt lại về giá trị tối đa
    }
  }

  // Cập nhật lại danh sách với số lượng mới
  setListAdd((prevData: any) => {
    const updatedData = prevData.map((item: any, i: any) =>
      i === row.index
        ? {
            ...item,
            quality: e || null,
            totalLineAmount: row?.original?.priceFinal * e,
          }
        : item,
    );

    return updatedData.map((item: any) =>
      row?.original?.listIdGift?.includes(item?.id)
        ? {
            ...item,
            // Tạm bỏ logic thay đổi số lượng của quà
            // quality: e || null,
          }
        : item,
    );
  });
};

export const getCustomerCod = (attribute1: string | undefined): any => {
  if (!attribute1) return null;

  try {
    const customerData = JSON.parse(attribute1);
    return customerData?.cod ?? null;
  } catch (error) {
    console.error("JSON parse error:", error);
    return null;
  }
};

export async function getDiscountDecisionSupportTable(
  customerId: string,
  itemCodes: string[],
) {
  const params = new URLSearchParams();
  params.append("customerId", customerId);
  itemCodes.forEach((itemCode) => {
    params.append("itemCodes", itemCode);
  });

  const url = `/api/v1/OrderHeader/get-discount-decision-support-table-for-retail?${params.toString()}`;

  try {
    const callapi = await repositoryDelivery.get<MessageResponse<any>>(url);
    if (callapi?.success) return callapi?.data;
    return null;
  } catch (error) {
    console.error("Error calling discount decision support API:", error);
    return null;
  }
}

export async function getDiscountDecisionSupportTableWholesale(
  customerId: string,
  itemCodes: string[],
) {
  const params = new URLSearchParams();
  params.append("customerId", customerId);
  itemCodes.forEach((itemCode) => {
    params.append("itemCodes", itemCode);
  });

  const url = `/api/v1/OrderHeader/get-discount-decision-support-table-for-wholesale?${params.toString()}`;

  try {
    const callapi = await repositoryDelivery.get<MessageResponse<any>>(url);
    if (callapi?.success) return callapi?.data;
    return null;
  } catch (error) {
    console.error("Error calling discount decision support API:", error);
    return null;
  }
}

/**
 * Xử lý logic đặc biệt cho voucher CMSN24
 * @param voucherCode - Mã voucher được nhập
 * @param orderData - Dữ liệu đơn hàng hiện tại
 * @param updateOrderHeader - Callback để cập nhật orderHeader
 * @returns Promise<boolean> - Trả về true nếu xử lý thành công
 */
export const handleCMSN24Logic = async (
  voucherCode: string,
  orderData?: any,
  updateOrderHeader?: (updates: any) => void,
): Promise<boolean> => {
  try {
    console.log("Xử lý voucher CMSN24:", voucherCode);
    console.log("Dữ liệu đơn hàng:", orderData);

    if (!orderData || !updateOrderHeader) {
      console.error("Thiếu dữ liệu đơn hàng hoặc callback cập nhật");
      return false;
    }

    const { orderHeader, totalAmount, payableAmount } = orderData;

    // Kiểm tra điều kiện đơn hàng >= 1 triệu VND
    const orderValue =
      totalAmount || payableAmount || orderHeader?.amountTotal || 0;
    const minOrderAmount = 1_000_000; // 1 triệu VNDget-discount-decision-support-table-for-retail

    if (orderValue < minOrderAmount) {
      NotificationExtension.Fails(
        `Đơn hàng phải có giá trị từ ${minOrderAmount.toLocaleString(
          "vi-VN",
        )} VNĐ trở lên để áp dụng voucher CMSN24`,
      );
      return false;
    }

    // Gọi API để lấy số tiền giảm cho voucher CMSN24
    const response = await repositoryMdm.get<MessageResponse<any>>(
      `api/v1/TblVoucherDetail/get-voucher-amount?voucherCode=${voucherCode}`,
    );

    if (response?.success) {
      const discountAmount = response?.data || 0;

      // Cập nhật orderHeader với thông tin giảm giá CMSN24
      updateOrderHeader({
        ...orderHeader,
        amountDiscountTotal: discountAmount,
        amountVoucher: discountAmount,
        attribute39: voucherCode,
        note: `Áp dụng voucher CMSN24 - Giảm ${discountAmount.toLocaleString(
          "vi-VN",
        )} VNĐ`,
      });

      // Thông báo thành công
      NotificationExtension.Success(
        `Đã áp voucher CMSN24 thành công! Giảm ${discountAmount.toLocaleString(
          "vi-VN",
        )} VNĐ`,
      );

      console.log("Xử lý voucher CMSN24 thành công!");
      return true;
    } else {
      console.error("Lỗi API hoặc voucher không hợp lệ");
      NotificationExtension.Fails(
        "Voucher CMSN24 không hợp lệ hoặc đã hết hạn",
      );

      // Đặt lại giá trị nếu API không thành công
      updateOrderHeader({
        ...orderHeader,
        amountDiscountTotal: 0,
        amountVoucher: 0,
        attribute39: "",
      });
      return false;
    }
  } catch (error) {
    console.error("Lỗi khi xử lý voucher CMSN24:", error);
    NotificationExtension.Fails("Lỗi khi xử lý voucher CMSN24");

    // Đặt lại giá trị nếu có lỗi
    if (updateOrderHeader && orderData?.orderHeader) {
      updateOrderHeader({
        ...orderData.orderHeader,
        amountDiscountTotal: 0,
        amountVoucher: 0,
        attribute39: "",
      });
    }
    return false;
  }
};

/**
 * Kiểm tra xem voucher có phải là loại đặc biệt không
 * @param voucherCode - Mã voucher
 * @returns boolean - True nếu là voucher đặc biệt
 */
export const isSpecialVoucher = (voucherCode: string): boolean => {
  const specialVouchers = ["CMSN24"];
  return specialVouchers.includes(voucherCode.toUpperCase());
};
